import type { ButtonHTMLAttributes, FC } from 'react';

import classNames from 'classnames';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { CardItem } from 'src/app/components/Elements/Card';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { RadioCardContainer, RadioCardContent, StyledHeader } from './styles';
import styles from './styles.module.scss';

const RadioCardItem: FC<{
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  isActive?: boolean;
  className?: string;
  data_cy?: string;
  header?: string;
}> = ({ onClick, isActive, children, className, data_cy, header = '' }) => {
  return (
    <CardItem
      tag="button"
      onClick={onClick}
      className={classNames(
        styles.component,
        styles._specific,
        {
          [styles.active]: isActive,
        },
        className
      )}
      data-cy={data_cy}
    >
      <RadioCardContainer>
        {header && <StyledHeader>{header}</StyledHeader>}

        <RadioCardContent>
          <div className={styles.selectArea}>
            <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_radio_button} />
          </div>
          <div>{children}</div>
        </RadioCardContent>
      </RadioCardContainer>
    </CardItem>
  );
};

export default RadioCardItem;
